module.exports = __webpack_public_path__ + "static/logo-08d04766bb6f8785582964781d9b3342.svg";